<button
    class="btn btn-sm btn-outline-secondary"
    (click)="editInvitation($event)"
>
    <nb-icon icon="fa-pen"></nb-icon>
</button>
